import { QuerySegment } from "./QuerySegment";
import { loadSegment } from "./QueryUtility";

export class QueryBranch extends QuerySegment {
  quorum?: number;
  values?: QuerySegment[];

  constructor(queryBranch: any) {
    super(queryBranch);
    this.fromJSON(queryBranch);
    return this;
  }

  fromJSON(queryBranch: any) {
    this.op = queryBranch?.op;
    this.quorum = queryBranch?.quorum;
    this.values = queryBranch?.values?.map((value: any) => {
      return loadSegment(value);
    });
    if (!this.values) { this.values = []; }
    if (queryBranch?.value) {
      this.values.push(loadSegment(queryBranch?.value));
    }
  }

  toAPIQuery() {
    let queryObj:any = {
      op: this.op
    }
    if (this.quorum) { queryObj.quorum = this.quorum; }
    if (this.values) { queryObj.values = this.values.map((value: any) => { return value?.toAPIQuery ? value.toAPIQuery() : value }); }
    return queryObj;
  }
}